// extracted by mini-css-extract-plugin
export var button = "menuHeader-module--button--YPJYK";
export var header = "menuHeader-module--header--VqW5p";
export var homelink = "menuHeader-module--homelink--hk+EQ";
export var name = "menuHeader-module--name--jfby9";
export var navbar = "menuHeader-module--navbar--gjH0p";